import {
    Container,
    Typography,
    Box,
    Stack,
    Button,
} from "@mui/material";

import { AdminApi } from "../../api/AdminApi";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import CommonImagePicker from "../../components/common/CommonImagePicker/CommonImagePicker";

export default function TestSimple() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);
    const [imageFile, setImageFile] = React.useState(null);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    let currentURL = "http://localhost:9220/media/1776708769_974275526a4c1cd721b0.png";

    // const testUpdateDashboardVideoCallback = async () => {
    //     console.log("update dashboard video");
    //     AdminApi.updateDashboardVideoCallback(
    //         1,
    //         {
    //             caption: "updated caption",

    // setValue(1234);
    const testCreateDashboardVideo = async () => {
        console.log("create dashboard video");
        if (!imageFile) {
            console.log("No image file selected");
            return;
        }
        // 
        //        const createDashboardVideoCallback = async (formData, thumbnailFile, callback) => {
        // import { AdminApi } from "../../api/AdminApi";
        AdminApi.createDashboardVideoCallback(
            {
                caption: "test caption 2",
                video_url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
                type: "youtube",
                thumbnail: "",
                thumbnail_file: imageFile,
            },
            (isSuccess, data) => {
                if (isSuccess) {
                    console.log("Dashboard video created successfully", data);
                } else {
                    console.log("Failed to create dashboard video");
                }
            }
        );
    }

    const testUpdateDashboardVideo = async () => {
        console.log("update dashboard video");
        if (!imageFile) {
            console.log("No image file selected");
            return;
        }
        AdminApi.updateDashboardVideoCallback(
            3,
            {
                caption: "updated caption",
                video_url: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
                type: "youtube",
                thumbnail: "",
                thumbnail_file: imageFile,
            },
            (isSuccess, data) => {
                if (isSuccess) {
                    console.log("Dashboard video updated successfully", data);
                } else {
                    console.log("Failed to update dashboard video");
                }
            }
        );
    }


    const setNewFile = (file) => {
        setImageFile(file);
    }

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Simple</Typography>


                <Box>
                    <p>Current Lang: {lang}</p>
                    <p>translateText: {t("testing.msg")}</p>
                    <pre>Value: {value} </pre>
                </Box>
                <pre>
                    currentURL: {currentURL}
                </pre>
                <CommonImagePicker
                    imageURL={currentURL}
                    onChange={(file) => setNewFile(file)}
                    onReset={() => setNewFile(null)}
                />
                <Button variant="contained" onClick={testCreateDashboardVideo} sx={{ mt: 2 }}>
                    Create Dashboard Video
                </Button>
                <Button variant="contained" onClick={testUpdateDashboardVideo} sx={{ mt: 2 }}>
                    Update Dashboard Video
                </Button>
            </Stack>
        </Container>
    )
}
